<!-- <div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Help</h4>
</div>
<div class="modal-body pb-0">
  <div class="d-flex flex-column justify-content-end pb-3 gap-2">
    <p>
      For questions regarding onboarding, hiring process, payroll and job
      functions, please contact the employer’s Human Resources department.
    </p>
    <p>
      For questions regarding DOT or compliance requirements, please contact
      your supervisor or Fleet/DOT manager.
    </p>
    <p>
      If you are experiencing technical difficulties using this website, please
      contact Lee Trans at
      <a href="tel:1-800-569-1675" class="link-primary">1-800-569-1675</a> and
      ask for the DQ department. (Office Hours: Monday-Friday 8am-5pm Central).
    </p>
    <button class="btn btn-light align-self-end" (click)="dismissModal()">
      Close
    </button>
  </div>
</div> -->

<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Help</h4>
</div>
<div class="modal-body pb-0">
  <div class="d-flex flex-column justify-content-end pb-3 gap-2">
    <iframe
      [src]="safeUrl"
      width="100%"
      height="640"
      allowfullscreen
      frameborder="0"
    ></iframe>
    <button class="btn btn-light align-self-end" (click)="dismissModal()">
      Close
    </button>
  </div>
</div>
